import React from "react";
import { castArray, concat, find, map } from "lodash-es";
import { StyledSelect as Select } from "../../components/inputs/StyledSelect";

export const ValuesSelect = ({ onChange, value, defaultFields = {}, customFields = {}, isDisabled = false, placeholder = null }) => {
  const defaultOptions = map(defaultFields, (f, k) => {
    return {
      label: f.label,
      value: k,
    };
  });
  const customOptions = map(customFields, (f, k) => {
    return {
      label: f.label,
      value: `custom:${k}`,
    };
  });
  const options = concat(defaultOptions, customOptions);
  const selectedValues = castArray(value);
  const selectedOptions = map(selectedValues, (v) => find(options, (o) => o.value === v));
  return (
    <Select
      value={selectedOptions}
      onChange={(values) => {
        onChange(map(values, "value"));
      }}
      options={options}
      isMulti={true}
      isDisabled={isDisabled}
      placeholder={placeholder}
    />
  );
};
